import { useMediaQuery } from '@patrianna/shared-hooks'
import { maskEmail } from '@patrianna/shared-utils/helpers'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { ChevronRight } from '@patrianna-icons/material-icons'
import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'

import { connectFacebook } from 'analyticActions/facebook/actions'
import Loader from 'components/Loader'
import Page from 'components/Page'
import ROUTES from 'config/routes.json'
import { withFooterPortal } from 'containers/Layouts/Layout/FooterPortal'
import { useRouterPushWithCallback } from 'containers/NavigationProvider'
import LogInToAccess from 'pageContainers/LogInToAccess'
import content from 'prismic-translates/page-profile.json'
import BackButtonLink from 'src/components/BackButtonLink'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import {
  facebookConnectedSelector,
  getUserSelector,
  isLoggedInSelector,
  oauthUsedSelector,
  getUserModeSelector,
} from 'store/modules/user/selectors'
// import UserAvatar from 'src/containers/UserAvatar'

import FacebookConnected from './components/FacebookConnected'
import LegalsLinks from './components/LegalsLinks'
import UserInfoRow from './components/UserInfoRow'
import Verifications from './components/Verifications'
import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

function MyAccountContent() {
  const routerPush = useRouterPushWithCallback()
  const query = useSearchParams()
  const pathname = usePathname()
  const dispatch = useAppDispatch()
  const loggedIn = useAppSelector(isLoggedInSelector)
  const userInfo = useAppSelector(getUserSelector)
  const oauthUsed = useAppSelector(oauthUsedSelector)
  const facebookConnected = useAppSelector(facebookConnectedSelector)
  const isMobile = useMediaQuery('xs')
  const userMode = useAppSelector(getUserModeSelector)

  const isSCUser = userMode?.includes?.('sweepstake')

  if (!loggedIn) {
    return <LogInToAccess />
  }

  return (
    <Page>
      <div className={classes.header}>
        {isMobile && <BackButtonLink href={ROUTES.HOME} className={classes.backButton} />}
        <h4 className={`mt-typography-h4 ${classes.title}`}>{t('title')}</h4>
      </div>

      {/* <UserAvatar userInfo={userInfo} avatarClass={classes.avatar} /> */}

      <UserInfoRow dataTest='my-account-email' title={t('account_email')} value={maskEmail(userInfo.email)} />

      <UserInfoRow dataTest='my-account-id' title={t('customer_id')} value={userInfo.customerId} />

      <UserInfoRow title={t('profile')}>
        <Link data-test='my-account-profile-details' href={ROUTES.MY_ACCOUNT_DETAILS} prefetch={false}>
          <span>{t('view_account_details')}</span>
          <ChevronRight className={classes.iconArrow} />
        </Link>
      </UserInfoRow>

      {!oauthUsed && (
        <UserInfoRow title={t('password')}>
          <Link href={ROUTES.CHANGE_PASSWORD} prefetch={false}>
            <span>{t('change_password')}</span>
            <ChevronRight className={classes.iconArrow} />
          </Link>
        </UserInfoRow>
      )}

      <UserInfoRow title={t('connect_accounts')}>
        <FacebookConnected
          connected={facebookConnected}
          handleClick={() => dispatch(connectFacebook(routerPush, query, pathname))}
        />
      </UserInfoRow>

      <UserInfoRow title={t('verification')}>
        <Verifications />
      </UserInfoRow>

      <UserInfoRow title={t('document_upload')}>
        <Link href={ROUTES.DOCUMENT_UPLOAD} prefetch={false}>
          <span>{t('upload_your_document')}</span>
          <ChevronRight className={classes.iconArrow} />
        </Link>
      </UserInfoRow>

      <UserInfoRow title={t('service')}>
        <Link href={ROUTES.NOTIFICATIONS} prefetch={false}>
          <span>{t('notifications')}</span>
          <ChevronRight className={classes.iconArrow} />
        </Link>
      </UserInfoRow>

      <UserInfoRow title={t('legal')} className='legalsLinks'>
        <LegalsLinks isSCUser={isSCUser} />
      </UserInfoRow>
    </Page>
  )
}

const MyAccountContentWithFooter = withFooterPortal(MyAccountContent)

function MyAccount() {
  const appInitialized = useAppSelector(isAppInitializedSelector)

  if (!appInitialized) {
    return <Loader />
  }

  return <MyAccountContentWithFooter isFooterVisible />
}

export default MyAccount
